import { render, staticRenderFns } from "./itemType.vue?vue&type=template&id=5583422b&scoped=true&"
import script from "./itemType.vue?vue&type=script&lang=js&"
export * from "./itemType.vue?vue&type=script&lang=js&"
import style0 from "./itemType.vue?vue&type=style&index=0&id=5583422b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5583422b",
  null
  
)

export default component.exports